export default function Label({ children, required }) {
  return (
    <label className="font-bold mb-2">
      {children}
      {required && <span className="text-topic-pink ml-2">*</span>}
    </label>
  )
}
